import { useEffect } from 'react';
import { MediaPlayerError } from '@yi/core';

import type { MediaError } from 'video.js';

import { useReportMediaPlaybackError } from './useReportMediaPlaybackError';
import { useMediaPlayer } from '../MediaPlayerProvider';

function getMessage(e: MediaError | null): string {
  if (e === null) {
    return `video.js threw an error, but the error stack is empty`;
  } else {
    const { code, message } = e;
    return JSON.stringify({ code, message });
  }
}

export function usePlayerErrors() {
  const { player } = useMediaPlayer();
  const report = useReportMediaPlaybackError();
  useEffect(() => {
    if (player !== null) {
      player.on('error', () => {
        const errorDetails = player.error();
        const error = new MediaPlayerError(getMessage(errorDetails));
        report(error);
      });
    }
  }, [player, report]);
}
